/**
 * Renders the object component based on the type of socket.
 * @returns {JSX.Element} The object component.
 */

import React from 'react';
import Control from '../store/control';
import MarkingTest from './markingTest';
import MarkingStandard from './markingStandard'
//import MarkingFinal from './markingFinal';

const ObjectBk = () => {
  const type     = Control.Get('type');
  const isTest   = (type == 'TestSocket'); 
  const isFinal  = (type == 'FinalDevice'); 
  const isFinalDeviceFinalStep = (type == 'FinalDeviceFinalStep')

  // As for now, test socket and final socket are the same, but only some modeling parameters are different.
  return (
    <>
      { isTest  ? <MarkingTest/> : null }
      { isFinal ? <MarkingTest/> : null }
      { isFinalDeviceFinalStep ? <MarkingStandard/> : null}
    </>
  );
  
};

export default ObjectBk;
